export const API_ERROR_MESSAGES = {
  404: "NOT_FOUND",
};

export const ASSETS_URL = `https://assets.appsmith.com`;

export const VERIFY_EMAIL_BANNER = `${ASSETS_URL}/upgrade-box.svg`;

export const APPSMITH_SALES_EMAIL = "sales@appsmith.com";
